import api from '../../services/api'
import {
  REPORT_LOADING,
  REPORT_COMPANIES_LOADED,
  REPORT_DETAILS_LOADED,
  REPORT_COMPANY_SELECTED,
  REPORT_DETAILS_NOTFOUND,
  REPORT_SYNCS_LOADED,
  REPORT_SYNC_SELECTED,
  REPORT_SYNC_DATE_SELECTED,
  REPORT_SYNC_COMPLETED
} from './reportsTypes'

export const handleReportLoading = () => {
  return {
    type: REPORT_LOADING,
  }
}

export const handleSyncCompleted = () => {
    return {
        type: REPORT_SYNC_COMPLETED
    }
}

export const handleReportCompaniesLoaded = (payload) => {
  return {
    type: REPORT_COMPANIES_LOADED,
    payload: payload,
  }
}

export const handleSelectedCompany = (payload) => {
  return {
    type: REPORT_COMPANY_SELECTED,
    payload: payload,
  }
}

export const handleSelectedSync = (payload) => {
  return {
    type: REPORT_SYNC_SELECTED,
    payload: payload
  }
}

export const handleReportDetailsLoaded = (payload) => {
  return {
    type: REPORT_DETAILS_LOADED,
    payload: payload,
  }
}

export const handleSyncsLoaded = (payload) => {
  return {
    type: REPORT_SYNCS_LOADED,
    payload: payload,
  }
}

export const handleReportDetailsNotFound = () => {
  return {
    type: REPORT_DETAILS_NOTFOUND,
  }
}

export const handleDeleteReport = () => {
  return {
    type: null
  }
}

export const fetchReportCompanyList = () => async (dispatch) => {
  dispatch(handleReportLoading())

  try {
    const res = await api.get(`/reports/companies`)
    const data = await res.json()
    dispatch(handleReportCompaniesLoaded(data))
  } catch (e) {
    dispatch(handleReportDetailsNotFound())
  }
}

export const reportingSyncDateUpdated = (payload) => {
    return {
        type: REPORT_SYNC_DATE_SELECTED,
        payload: payload
    }
}

export const reportingSyncSelected = (payload, companyPayload) => async (dispatch) => {
  dispatch(handleReportLoading())

  let copy = Object.assign({}, companyPayload)
  copy.syncId = payload.value;

  dispatch(handleSelectedSync(payload))
  dispatch(reportingCompanySelected(copy))
}

export const runSync = () => async (dispatch) => {
    try {
        const res = await api.get(`/reports/veeamSync`)
        const data = await res.json()
        dispatch(handleSyncCompleted())
    } catch (e) {
        dispatch(handleReportDetailsNotFound())
    }
}

export const reportingCompanySelected = (payload) => async (dispatch) => {
  dispatch(handleReportLoading())

  try {

    let syncId = null;
    if (payload.syncId !== null) {
      syncId = payload.syncId;
    }

    const [reportRes, syncsRes] = await Promise.all([
      api.get(`/reports/companies/${payload.value}/Sync/${syncId}`),
      api.get(`/reports/SyncHistory`),
    ])

    if (reportRes.ok && syncsRes.ok) {
      const reportData = await reportRes.json()
      const syncData = await syncsRes.json()
      dispatch(handleSelectedCompany(payload))
      dispatch(handleSyncsLoaded(syncData))
      dispatch(handleReportDetailsLoaded(reportData))
    } else {
      dispatch(handleSelectedCompany(payload))
      dispatch(handleReportDetailsNotFound())
    }

  } catch (e) {
    console.log(e)
    dispatch(handleReportDetailsNotFound())
  }
}
